import {FC} from 'react';
import {useHistory} from 'react-router-dom';
import routes from '../routes';
import {useTranslation} from 'react-i18next';
import {UserListProps} from '../../../constants/types';
import EnsurePermission from '../../common/EnsurePermission';
import permissionsInfo from '../../../constants/permissionsInfo';
import {useAppSelector} from '../../../store/hooks';
import classNames from 'classnames';
import IconButton from '@mui/material/IconButton';
import ModeEditIcon from '@mui/icons-material/ModeEdit';

type UserRowProps = {
  user: UserListProps,
  isSysConfPath: boolean
}

const UserRow: FC<UserRowProps> = ({
  user,
  isSysConfPath
}) => {
  const {permissions: currentUserPermissions} = useAppSelector((state) =>
    state.permissions);

  const {id, firstName, lastName, email, invitationAccepted} = user;
  const history = useHistory();
  const {t} = useTranslation('common');
  const userLink = isSysConfPath ?
    routes.usersItem(id) : routes.tenantUsersItem(id);

  const userEditPermissions = isSysConfPath ?
  permissionsInfo.users.view : permissionsInfo.tenants_config.users.view;

  const havePermissionToEditUser = userEditPermissions
      .some((permission) => currentUserPermissions.includes(permission));

  const tableDataClassName = classNames('cell', {
    'cursor-pointer': havePermissionToEditUser,
    'disabled': !havePermissionToEditUser
  });

  const goToUser = () => history.push(userLink);

  return (
    <tr>
      <td className={tableDataClassName} onClick={goToUser}>{firstName}</td>
      <td className={tableDataClassName} onClick={goToUser}>{lastName}</td>
      <td className={tableDataClassName} onClick={goToUser}>{email}</td>
      {!isSysConfPath &&
        <td className={tableDataClassName} onClick={goToUser}>
          {invitationAccepted ? t('accepted') : t('invited')}
        </td>}
      <td className="cell narrow-cell">
        <EnsurePermission elementPermissions={userEditPermissions}>
          <IconButton
            className="icon-button gray small"
            onClick={goToUser}
          >
            <ModeEditIcon className="icon" />
          </IconButton>
        </EnsurePermission>
      </td>
    </tr>
  );
};

export default UserRow;
